import React from 'react';
// import { Link } from 'react-router-dom';

// import {PORTFOLIOS} from '../../data/portfolios';
import * as PORTFOLIOS from '../../data/portfolios';



export default class Component extends React.Component {

  render (){

    const portfolio = PORTFOLIOS['ed3h1vw1rx0p'];
    const stocks = portfolio.stocks.filter(function(ticker){return ticker.symbol !== undefined});

    return (
      <section id="portfolio" className="content-section text-center py-5 my-5">

        <h1>Customize</h1>
        
        <div className="row">
          <div className="col-1">
          </div>
          <div className="col-9">
            <div className="mx-1">
              
              <h3>{portfolio.title}</h3>

              <div className="my-5">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th className="">Ticker</th>
                      <th className="">Name</th>
                      <th className="">Open Price</th>
                      <th className="">52w high</th>
                      <th className="">52w low</th>
                      <th className="">Dividend Rate</th>
                      <th className="">Last Dividend Date</th>
                      <th className="">Last Dividend Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stocks.map(function(ticker, idx){
                      return (
                        <tr key={idx}>
                          <th className="">{ticker.symbol}</th>
                          <td><a href={ticker.website} className="">{ticker.longName}</a></td>
                          <td>{ticker.open}</td>
                          <td>{ticker.fiftyTwoWeekHigh}</td>
                          <td>{ticker.fiftyTwoWeekLow}</td>
                          <td>{ticker.dividendRate}</td>
                          <td>{(ticker.lastDividendDate)? (new Date(ticker.lastDividendDate*1000).toISOString().split('T')[0]) : ''}</td>
                          <td>{ticker.lastDividendValue}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div className="col-2">
            <div className="border rounded">
              AD here
            </div>
          </div>
        </div>

        <div className="">
          <div className="btn btn-lg btn-success" style={{cursor: "pointer"}}>
            Customize this portfolio!
          </div>
        </div>

      </section>
    )
  }
}